import { jsx as _jsx } from "react/jsx-runtime";
import { useTopicPageViewsTopicEditor } from "../TopicPage_Views_Topic/TopicPageViewsTopicEditorContext";
import TopicPageSectionInput from "./TopicPageSectionInput";
const TopicPageSectionNewEditor = (props)=>{
    const { topic  } = props;
    const { state: { editor , variant  } ,  } = useTopicPageViewsTopicEditor();
    return /*#__PURE__*/ _jsx(TopicPageSectionInput, {
        topic: topic,
        open: editor === "CREATE_SECTION" ? variant : undefined
    });
};
export default TopicPageSectionNewEditor;
